export default (params) => {
  const { showOrHideWisedocModal, handleUploadDocument } = params;
  return [
    {
      type: 'button',
      text: 'Proceed',
      dataTestId: 'proceedButton',
      triggerFunction: () => {
        handleUploadDocument();
        showOrHideWisedocModal(false);
      },
    },
    {
      type: 'button',
      text: 'Cancel',
      dataTestId: 'cancelButton',
      triggerFunction: () => showOrHideWisedocModal(false),
    },
  ];
};

const WISEDOC_IMPORT_MESSAGE = 'Importing the file will ';

const WISEDOC_IMPORT_MESSAGE_PART_TWO =
  'your current data in the file. Are you sure you want to proceed?';

const createRichTextArray = (message, messagePartTwo) => [
  { key: 'msg1', text: message, class: '' },
  { key: 'replace', text: 'replace', class: 'bold' },
  { key: 'msg2', text: ' and may ', class: '' },
  { key: 'delete', text: 'delete', class: 'bold' },
  { key: 'msg3', text: ` ${messagePartTwo}`, class: '' },
];

export const richTextArray = createRichTextArray(
  WISEDOC_IMPORT_MESSAGE,
  WISEDOC_IMPORT_MESSAGE_PART_TWO,
);
export const ACCEPTED_IMPORT_FILE_TYPES = {
  pdf: 'application/pdf',
};

export const ACCEPTED_IMPORT_FILE_TYPES_ERROR_MESSAGE =
  'Apologies, but we can only accept pdf. Please try again';

export const IMPORT_FILE_SIZE_LIMIT = 5;

export const IMPORT_FILE_SIZE_ERROR_MESSAGE = `File size should be less than ${IMPORT_FILE_SIZE_LIMIT} MB. Please try again`;

export const IMPORT_FILE_ERROR_MESSAGE =
  'Error reading the file. Please try again';

export const ACCEPTED_IMPORT_FILE_EXTENSIONS = '.pdf';

export const IMPORT_FILE_SUCCESS_MESSAGE = 'File imported successfully.';

export const IMPORT_FILE_IN_PROGRESS_MESSAGE =
  'Import is in progress. Please reload the page after a few moments. Thank you for your patience.';
export const COMPONENT_TYPE_IMPORT_DOC = 'import-document';
